<!--
  File name: NPCReportHeader.vue
  Program Description:
    - This component contains the design for the NPC Report header
    - When accessed, it renders the logo, and the Data Breach Notification Form
    number being used in the export generation
-->
<template>
  <v-container>
    <v-row>
      <v-col cols="3">
        <img
          :src="$metaData.app.logo"
          height="80"
          width="150"
        >
      </v-col>
      <v-col
        cols="9"
        style="padding-top: 17px; font-family: Source Sans Pro"
      >
        <p>
          <b>DATA BREACH NOTIFICATION MANAGEMENT SYSTEM (DBNMS)</b><br>
          Personal Data Breach Notification Form<br>
          {{ data && data.dbnNumber }}
        </p>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: null
    }
  }
}
</script>

<style scoped>
.header-text {
  white-space: nowrap;
  line-height: 0.90;
  padding-left: 20px;
}
.header-email {
  color: #1a1aff;
  font-weight: bold;
  text-decoration: underline;
}
p {
  margin-top: 3px;
}
.font-bold {
  font-weight: 900;
}
.title {
  font-family: Cambria, serif;
  font-size: 11pt;
}
.name {
  font-family: Cambria, serif;
  font-size: 12pt;
}
.details {
  font-family: Cambria, serif;
  font-size: 9pt;
}
</style>
